import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import { api } from "@shared-server/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
interface PromptCountInChatsProps {
  startDate: Date;
  endDate: Date;
}
const BUCKETS = [{
  label: "1",
  min: 1,
  max: 1
}, {
  label: "2-3",
  min: 2,
  max: 3
}, {
  label: "4-5",
  min: 4,
  max: 5
}, {
  label: "6-10",
  min: 6,
  max: 10
}, {
  label: "11-15",
  min: 11,
  max: 15
}, {
  label: "15+",
  min: 16,
  max: Infinity
}];
export const PromptCountInChats = props => {
  const $ = _c(15);
  let t0;
  if ($[0] !== props.endDate || $[1] !== props.startDate) {
    t0 = {
      startDate: props.startDate,
      endDate: props.endDate
    };
    $[0] = props.endDate;
    $[1] = props.startDate;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const coreMetricsQuery = api.coreMetrics.promptsCountPerChat.useQuery(t0);
  let t1;
  bb0: {
    const data = coreMetricsQuery.data as Record<string, number> | undefined;
    if (!data) {
      let t2;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[3] = t2;
      } else {
        t2 = $[3];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[4] !== data) {
      const buckets = {};
      for (const bucket of BUCKETS) {
        buckets[bucket.label] = 0;
      }
      for (const [countStr, chatsCount] of Object.entries(data)) {
        const count = Number(countStr);
        const bucket_0 = BUCKETS.find(b => count >= b.min && count <= b.max);
        if (bucket_0) {
          buckets[bucket_0.label] = (buckets[bucket_0.label] ?? 0) + chatsCount;
        }
      }
      t2 = BUCKETS.map(b_0 => ({
        bucket: b_0.label,
        chats: buckets[b_0.label]
      }));
      $[4] = data;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = t2;
  }
  const chartData = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className="mb-2 mt-8">{"Prompts count in chats"}</h2>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CartesianGrid strokeDasharray="3 3" />;
    t4 = <XAxis dataKey="bucket" />;
    t5 = <YAxis allowDecimals={false} />;
    t6 = <Tooltip />;
    t7 = <Legend />;
    t8 = <Bar dataKey="chats" fill="#006e96" name="Chats" />;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[13] !== chartData) {
    t9 = <div>{t2}<ResponsiveContainer width="100%" height={250}><BarChart data={chartData}>{t3}{t4}{t5}{t6}{t7}{t8}</BarChart></ResponsiveContainer></div>;
    $[13] = chartData;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};